import { createApiModules } from "@repo/exit-calc-api-client";
import { baseHttpClient } from "@mobile/api/http-client";

export const API = createApiModules(baseHttpClient);
